export const obtenerValorReserva = (entidad, habitacion)=>{

    let valor = parseInt(habitacion.tarifa)
    let valorAcompa = habitacion.tarifaAcompanante * entidad.numAcompanantes ? parseInt(entidad.numAcompanantes) : 0
    let valorNinos = habitacion.tarifaNinos *  entidad.numNinos ? parseInt(entidad.numNinos) : 0

    console.log(valorNinos, valorAcompa, valor)

    return valorNinos + valorAcompa + valor

}